export function buildApproachPayload(students) {
  return {
    students: students.map((student) => ({
      customer_id: student.customer_id,
      approach: Boolean(student.approach),
    })),
  };
}

export function buildAssistancePayload(students) {
  return {
    students: students.map((student) => ({
      customer_id: student.customer_id,
      assistance: Boolean(student.assistance),
    })),
  };
}

function ensureRequestSucceeded(result) {
  if (result && result.ok) return;

  const error = new Error(
    (result && result.message) || "No se pudo cerrar la clase."
  );
  error.status = result && result.status;
  throw error;
}

export async function closeClassSequentially({
  classId,
  students,
  updateApproach,
  updateAssistance,
}) {
  const approachResult = await updateApproach(
    classId,
    buildApproachPayload(students)
  );
  ensureRequestSucceeded(approachResult);

  const assistanceResult = await updateAssistance(
    classId,
    buildAssistancePayload(students)
  );
  ensureRequestSucceeded(assistanceResult);
}

export function messageForClassCloseError(error) {
  if (error && error.status === 409) {
    return "La clase ya fue cerrada. No se puede registrar de nuevo.";
  }
  if (error && error.status === 500) {
    return "La ventana de registro se cerró. Pasaron más de 70 minutos desde el inicio de la clase.";
  }
  if (error && error.status === 404) {
    return "La clase no existe.";
  }
  return (error && error.message) || "No se pudo cerrar la clase.";
}
